
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/writing/[slug]",
      function () {
        return require("private-next-pages/writing/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/writing/[slug]"])
      });
    }
  